const projects = [
  {
    slug: 'adaptive-room-environment',
    title: 'Adaptive Room Environment',
    summary: 'ARE is a system that maps environmental inputs to environmental outputs using configuration. At its simplest, ARE is about defining cause-and-effect relationships in an environment: when this input changes, that part of the environment responds. In other words, instead of programming every interaction individually, ARE aims to describe interactions through configuration.',

    // Optional
    tags: [],
    liveUrl: undefined,
    sourceUrl: undefined,
    relatedPostSlugs: ['are-introduction'],
  },
  {
    slug: 'georgia-tech',
    title: 'Georgia Tech',
    summary: 'I am currently a Masters student in Computer Science at Georgia Institute of Technology. This project is a collection of articles surrounding my experiences and coursework in the program.',

    // Optional
    tags: ["Georgia Tech", "Human-Computer Interaction"],
    liveUrl: undefined,
    sourceUrl: undefined,
    relatedPostSlugs: ['gt-cs-6750-hci'],
  },

  /* {
  slug: "test-all-project-content",
  title: "[TEST] All project content",
  summary:
    "Verify image, summary, tags, live link, source link, two related articles, bidirectional navigation, and a clean console.",
  image:
    "https://picsum.photos/seed/test-all-project-content/1200/675.webp",
  tags: ["React", "Architecture", "Testing"],
  liveUrl: "https://example.com",
  sourceUrl: "https://github.com/",
  relatedPostSlugs: [
    "test-project-overview",
    "test-project-deep-dive",
  ],
},
{
  slug: "test-all-project-content-minus-image",
  title: "[TEST] All project content minus image",
  summary:
    "Verify summary, tags, live link, source link, two related articles, bidirectional navigation, and a clean console.",
  tags: ["React", "Architecture", "Testing"],
  liveUrl: "https://example.com",
  sourceUrl: "https://github.com/",
  relatedPostSlugs: [
    "test-project-overview",
    "test-project-deep-dive",
  ],
},
{
  slug: "test-minimal-project",
  title: "[TEST] Required fields only",
  summary:
    "Verify that a project with only required fields renders without empty tags, links, image, or article sections.",
  relatedPostSlugs: [],
},
{
  slug: "test-partial-project",
  title: "[TEST] Partial optional content",
  summary:
    "Verify an image, tags, and source link render while the live link and related-article section remain absent.",
  image:
    "https://picsum.photos/seed/test-partial-project/1200/675.webp",
  tags: ["Partial", "Edge case"],
  sourceUrl: "https://github.com/",
},
{
  slug: "test-invalid-blog-reference",
  title: "[TEST] Invalid blog relationship",
  summary:
    "Verify the page still renders, the missing article is omitted, and exactly one warning appears in the console.",
  relatedPostSlugs: ["test-project-overview", "missing-blog-test"],
}, */
];

export default projects;